//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useContext, useState, useCallback, useRef } from 'react';
// import { useContext, useEffect, useCallback, useContext, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
// import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
// import Navbar from '../helpers/Header';
// import LeftNavigation from '../LeftNavigation';
import { makeStyles } from '@material-ui/core';
import SimpleBar from 'simplebar-react';
// import SearchIcon from '@material-ui/icons/Search';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import noJobFound from '../images/NoJobFound/noJobFound.png';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { unsubscribeRealtimeUpdates, logEvent, logPageView } from '../system/firebase';
import { AppContext, LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';
import { getFormattedDate } from '../common/dateHelper';
import {
    ANALYTICS_EVENT_JS_APPLIED_JOB,
    ANALYTICS_EVENT_JS_MY_JOBS_SEARCH,
    DASHBOARD_MY_JOBS,
    PAGE_TITLE_JS_MY_JOBS,
    SORT_OPTION_NEWEST_FIRST,
    SORT_OPTION_OLDEST_FIRST,
} from '../common/constants';
import { getUniqueKey } from '../common/arrayHelper';
import { getUserDateFormat } from '../common/dateHelper';
import { applyJob } from '../common/services/jobCenterServices';
import {
    ELASTICSEARCH_PAGE_SIZE,
    ELASTICSEARCH_SORT_OPTIONS,
    ELASTICSEARCH_SORT_OPTION_APPLY_DATE_ASC,
    ELASTICSEARCH_SORT_OPTION_APPLY_DATE_DESC,
    ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_ASC,
    ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC,
} from '../common/elasticSearchHelper';
import { getFullNameByUser } from '../common/textHelper';
import { PLACEHOLDER_SEARCH_BY_JOB_TITLE } from '../common/placeholderHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { loadMyJobsByUserId, fetchJsSavedJobs, fetchJsAppliedJobs } from '../common/services/myJobsServices';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../common/elemental/AfitdPageHead';
import AfitdTypography from '../common/elemental/AfitdTypography';
import AfitdButtonGroup from '../common/elemental/AfitdButtonGroup';
import AfitdButton from '../common/elemental/AfitdButton';
import AfitdDropDown from '../common/elemental/AfitdDropDown';
import SingleJobDialog from '../empDashboardMyJobs/subComponents/SingleJobDialog';
import Footer from '../dashboard/subComponents/Footer';
import BrandPageDialog from '../empBrandPage/subComponents/BrandPageDialog';
import AfitdPagination from '../common/elemental/AfitdPagination';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import CompanyInfo from './subComponents/CompanyInfo';
// import Branding from './subComponents/Branding';
// // import SocialMediaPortfolio from './subComponents/SocialMediaPortfolio';
import SearchInput from './subComponents/SearchInput';
import JobCard from './subComponents/JobCard';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _findIndex from 'lodash/findIndex';
import _slice from 'lodash/slice';
import _cloneDeep from 'lodash/cloneDeep';
import _remove from 'lodash/remove';
import _omit from 'lodash/omit';
import _forEach from 'lodash/forEach';
import _orderBy from 'lodash/orderBy';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import _some from 'lodash/some';

import { differenceInSeconds } from 'date-fns';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            height: '100%',
            background: '#FAFAFC',
        },
        contentScrollable: {
            width: '100%',
            height: '100%',
            overflowY: 'hidden',
            // overflowY: 'auto',
            // '&::-webkit-scrollbar-track': { borderRadius: '10px', background: 'none' },
            // '&::-webkit-scrollbar': { width: '8px', backgroundColor: '#F5F5F5' },
            // '&::-webkit-scrollbar-thumb': { borderRadius: '10px', backgroundColor: 'rgba(0,0,0,0.2)' },
        },
        myJobs: {
            padding: '40px 50px',
            paddingTop: 0,
            [theme.breakpoints.down('md')]: { padding: '24px 32px', paddingTop: 0 },
            [theme.breakpoints.down('sm')]: { padding: '16px', paddingTop: 0 },
        },
        searchContainer: { margin: '24px 0', display: 'flex', alignItems: 'center' },
        jobsCountText: { fontWeight: 'bold', [theme.breakpoints.down('sm')]: { fontSize: 17 } },
        sortBox: { display: 'flex', alignItems: 'center', flex: 1, justifyContent: 'flex-end' },
        sortText: { padding: '0 8px' },
        dropdownContainer: { width: 200, [theme.breakpoints.down('sm')]: { width: 135 } },

        header: {
            height: '128px',
        },
        headerLeft: { display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' },
        headerRight: { display: 'flex', flexGrow: 4, justifyContent: 'flex-end' },

        headerTitle: {
            marginTop: '38px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        headerTitleText: {
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '26px',
            lineHeight: '30px',
            color: '#111E14',
        },
        headerToday: {
            marginTop: '10px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        todayIcon: {
            fontSize: '16px',
            color: 'rgba(17, 30, 20, 0.4)',
        },
        todayContainer: {
            marginTop: '1px',
            marginLeft: '9px',
            fontSize: '13px',
            color: 'rgba(17, 30, 20, 0.6)',
        },

        headerButtons: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' },
        helpOutlineIcon: {
            fontSize: '18px',
            backgroundColor: '#F0F2F6',
            padding: '8px',
            borderRadius: '50%',
            marginRight: '20px',
            marginTop: '2px',
        },
        savedAppliedButtonGroup: {
            '& :not(:last-child)': {
                borderRight: 'none',
            },
        },

        content: {
            flex: 1,
            overflowY: 'hidden',
            marginTop: 0,
            marginBottom: 0,
            borderRadius: '0 0 10px 10px',
            backgroundColor: '#fff',
        },
        paginationContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 10,
        },
        myJobsSearchContainer: {
            backgroundColor: '#fff',
            padding: '40px 50px 0px 50px',
            borderRadius: '10px 10px 0 0',
            [theme.breakpoints.down('sm')]: { padding: '16px', paddingBottom: 0 },
        },
        noResultIcon: {
            fontSize: 280,
            color: '#808080',
        },
        noResultContainer: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
        },
        noResultText: {
            fontSize: 20,
            fontWeight: 'bold',
        },
        noResultTryText: {
            fontSize: 16,
            color: '#6F6D7A',
        },
        noResultTextContainer: {
            textAlign: 'center',
            marginTop: '-20px',
        },
        noJobFoundContainer: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' },
        noJobFoundImg: { width: 450, [theme.breakpoints.down('sm')]: { width: 340 } },
        noJobListingText: { fontSize: 20, fontWeight: 'bold' },
        noJobListingPara: { fontSize: 16, color: '#6F6D7A' },
        noJobTextContainer: { textAlign: 'center' },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        userDateFormat,
        // currentUser,
        searchResultTotal,
        myJobsData,
        jobList,
        isSavedView,
        sortByNewest,
        // setSortByNewest,
        handleClickSavedButton,
        handleClickAppliedButton,
        handleChangeSort,
        // handleClickJobTitle,
        jobModalIdx,
        setJobModalIdx,
        handleClickApplyNow,
        handleRunSearch,
        brandPageDialogInfo,
        // setBrandPageDialogInfo,
        handleCloseBrandPageDialog,
        handleClearFilters,
        // handleDeleteJob,
    } = params;

    const brandPageDialogOpen = _get(brandPageDialogInfo, 'open');
    const brandPageEmployerId = _get(brandPageDialogInfo, 'employerId');

    const employers = _get(myJobsData, 'employers');
    const jobsCountText = `${searchResultTotal} ${isSavedView ? 'Saved' : 'Applied'} job${searchResultTotal === 1 ? '' : 's'}`;

    const sortOptions = [SORT_OPTION_NEWEST_FIRST, SORT_OPTION_OLDEST_FIRST];
    const jobModalCurrentJobs = jobList;

    const defns = {
        root: { item: true, container: true, direction: 'column', lg: 12, md: 12, sm: 12, xs: 12 },
        header: { item: true, container: true },
        todayText: { variant: 'caption', value: getFormattedDate(new Date(), userDateFormat), clsBigCaption: true },
        savedAppliedButtonGroup: { disableElevation: true },
        jobsCountText: { variant: 'h6', value: jobsCountText },
        sortText: { variant: 'body1', color: 'secondary', clsLightBold: true },
        sortDropdown: { options: sortOptions, value: sortByNewest ? SORT_OPTION_NEWEST_FIRST : SORT_OPTION_OLDEST_FIRST, handleChange: e => handleChangeSort(e.target.value) },

        content: { container: true, item: true, spacing: 0 },
        savedButton: { color: isSavedView ? 'secondary' : '', onClick: handleClickSavedButton },
        appliedButton: { color: isSavedView ? '' : 'secondary', onClick: handleClickAppliedButton },
        jobModal: {
            open: jobModalIdx !== null,
            close: () => setJobModalIdx(null),
            currentJobs: jobModalCurrentJobs,
            idx: jobModalIdx,
            isJobSeeker: true,
            isAppliedView: !isSavedView,
            applyNowOnClick: handleClickApplyNow,
            employers,
        },

        searchInput: {
            placeholder: PLACEHOLDER_SEARCH_BY_JOB_TITLE,
            onSearch: handleRunSearch,
            showClearFilters: true,
            onClearFilters: handleClearFilters,
        },
        brandPageDialog: {
            open: brandPageDialogOpen,
            onClose: handleCloseBrandPageDialog,
            employerId: brandPageEmployerId,
        },
    };

    setClassNameInDefns(defns, classes);
    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const queryInitState = {
    searchText: null,
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const MyJobs = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    const appContext = useContext(AppContext);
    const layoutContext = useContext(LayoutContext);
    const { userId, currentUser, esToken, setEsToken } = appContext;
    const {
        setSnackbarMessage,
        setSnackbarErrorMessage,
        setAsyncCallCount,
        tempBookmarkedJobs,
        // setTempBookmarkedJobs,
        tempUnbookmarkedJobs,
        setTempUnbookmarkedJobs,
        tempAppliedJobs,
        // setTempAppliedJobs,
        tempUpdatedJobNotes,
        setTempUpdatedJobNotes,
    } = layoutContext;
    const userDateFormat = getUserDateFormat(appContext);

    const theme = useTheme();
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));

    const myRef = useRef(null);
    const lastQuery = useRef();
    const lastQueryPageNumber = useRef();
    const lastIsSavedView = useRef();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [query, setQuery] = useState(queryInitState);
    const [sortTag, setSortTag] = useState(ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC);
    const [searchResultTotal, setSearchResultTotal] = useState(0);
    const [currentPageNumber, setCurrentPageNumber] = React.useState(1);
    const [myJobsData, setMyJobsData] = useState(null);
    const [isSavedView, setIsSavedView] = useState(true);
    const [jobList, setJobList] = useState([]);
    const [sortByNewest, setSortByNewest] = useState(true);
    const [jobModalIdx, setJobModalIdx] = useState(null);
    const [brandPageDialogInfo, setBrandPageDialogInfo] = useState(null);
    const [isSearched, setIsSearched] = React.useState(false);

    //---------------------------------------------------------------------
    // ElasticSearch
    //---------------------------------------------------------------------
    const runSearch = useCallback(
        async ({ page = 1, isSavedView, query } = {}) => {
            const fetchJobs = isSavedView ? fetchJsSavedJobs : fetchJsAppliedJobs;

            const queryWithUserId = { ...query, parentId: userId };

            setAsyncCallCount && setAsyncCallCount(prev => prev + 1);
            const searchResult = await fetchJobs({
                queryObject: queryWithUserId,
                from: page,
                esToken,
                setEsToken,
            });

            let searchResultCount = _get(searchResult, 'total', 0);
            let list = _get(searchResult, 'list', []);

            if (isSavedView) {
                // illusion of real-time for bookmarked jobs
                const bookmarkedJobKeys = _keys(tempBookmarkedJobs);
                const bookmarkedJobList = _orderBy(
                    _map(bookmarkedJobKeys, jobId => tempBookmarkedJobs[jobId]),
                    ['updateDt'],
                    ['asc'],
                );
                _forEach(bookmarkedJobList, bookmarkedJob => {
                    const data = bookmarkedJob.data || {};
                    // we only care about the ones that was updated within the last 30 seconds
                    if (differenceInSeconds(new Date(), bookmarkedJob.updateDt) < 30) {
                        // if page 1 and newest first but new job not in result, prepend it
                        if (page === 1 && query?.sortTag === ELASTICSEARCH_SORT_OPTIONS[ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC]) {
                            if (!_some(list, item => item.uid === data.uid)) {
                                // add the new job to the list
                                list = [data, ...list];
                                searchResultCount++;
                            }
                        }
                    }
                });

                // illusion of real-time for unbookmarked jobs
                const tempUnbookmarkedKeys = _keys(tempUnbookmarkedJobs);
                const tempUnbookmarkedJobList = _orderBy(
                    _map(tempUnbookmarkedKeys, jobId => tempUnbookmarkedJobs[jobId]),
                    ['deleteDt'],
                    ['asc'],
                );
                _forEach(tempUnbookmarkedJobList, unbookmarkedJob => {
                    const uid = unbookmarkedJob.id;
                    // we only care about the ones that was deleted within the last 30 seconds
                    if (differenceInSeconds(new Date(), unbookmarkedJob.deleteDt) < 30) {
                        // if the deleted job is in the result, remove it
                        const foundJobIdx = _findIndex(list, item => item.uid === uid);

                        if (foundJobIdx >= 0) {
                            // remove it from the job list
                            list = [..._slice(list, 0, foundJobIdx), ..._slice(list, foundJobIdx + 1)];
                            searchResultCount--;
                        }
                    }
                });
            } else {
                // illusion of real-time for applied jobs
                const appliedJobKeys = _keys(tempAppliedJobs);
                const appliedJobList = _orderBy(
                    _map(appliedJobKeys, jobId => tempAppliedJobs[jobId]),
                    ['updateDt'],
                    ['asc'],
                );
                _forEach(appliedJobList, appliedJob => {
                    const data = appliedJob.data || {};
                    // we only care about the ones that was updated within the last 30 seconds
                    if (differenceInSeconds(new Date(), appliedJob.applyDt) < 30) {
                        // if page 1 and newest first but new job not in result, prepend it
                        if (page === 1 && query?.sortTag === ELASTICSEARCH_SORT_OPTIONS[ELASTICSEARCH_SORT_OPTION_APPLY_DATE_DESC]) {
                            if (!_some(list, item => item.uid === data.uid)) {
                                // add the new job to the list
                                list = [data, ...list];
                                searchResultCount++;
                            }
                        }
                    }
                });
            }

            // illusion of real-time for updated notes
            const tempUpdatedNoteKeys = _keys(tempUpdatedJobNotes);
            const tempUpdatedJobNoteList = _orderBy(
                _map(tempUpdatedNoteKeys, jobId => tempUpdatedJobNotes[jobId]),
                ['updateDt'],
                ['asc'],
            );
            _forEach(tempUpdatedJobNoteList, updatedNote => {
                const uid = updatedNote.id;
                const note = updatedNote.data;
                // we only care about the ones that was deleted within the last 30 seconds
                if (differenceInSeconds(new Date(), updatedNote.updateDt) < 30) {
                    // if the deleted job is in the result, remove it
                    const foundJobIdx = _findIndex(list, item => item.uid === uid);
                    const modifiedJob = { ...list[foundJobIdx], note };

                    if (foundJobIdx >= 0) {
                        list = [..._slice(list, 0, foundJobIdx), modifiedJob, ..._slice(list, foundJobIdx + 1)];
                    }
                }
            });

            setSearchResultTotal(searchResultCount);
            setJobList(list);

            query?.searchText && logEvent(ANALYTICS_EVENT_JS_MY_JOBS_SEARCH);

            // myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

            setAsyncCallCount && setTimeout(() => setAsyncCallCount(prev => prev - 1), 500);
        },
        [userId, esToken, setEsToken, setAsyncCallCount, tempBookmarkedJobs, tempUnbookmarkedJobs, tempAppliedJobs, tempUpdatedJobNotes],
    );

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(PAGE_TITLE_JS_MY_JOBS);
    }, []);

    // load initial data
    useEffect(() => {
        let unsubscribeLoadMyJobsByUserId = null;

        if (userId) {
            setAsyncCallCount(prev => prev + 1);
            unsubscribeLoadMyJobsByUserId = loadMyJobsByUserId({ userId, setData: setMyJobsData });
            setTimeout(() => setAsyncCallCount(prev => prev - 1), 500);
        }
        // unsubscribe realtime update on unmount
        return () => {
            unsubscribeRealtimeUpdates([unsubscribeLoadMyJobsByUserId]);
        };
    }, [userId, setMyJobsData, setAsyncCallCount]);

    // run search when query / current page number / saved/applied view has changed
    useEffect(() => {
        if (query && currentPageNumber) {
            const sameQuery = _isEqual(lastQuery.current, query);
            const samePageNumber = lastQueryPageNumber.current === currentPageNumber;
            const sameView = lastIsSavedView.current === isSavedView;

            // if query is same as last, do not search
            if (lastQuery && lastQueryPageNumber && (!sameQuery || !samePageNumber || !sameView)) {
                runSearch({ query, page: currentPageNumber, isSavedView });

                // remember the query and the page number
                lastQuery.current = _cloneDeep(query);
                lastQueryPageNumber.current = currentPageNumber;
                lastIsSavedView.current = isSavedView;
            }
        }
    }, [query, currentPageNumber, isSavedView, runSearch, lastQuery, lastQueryPageNumber, lastIsSavedView]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const brandPageDialogOpen = _get(brandPageDialogInfo, 'open');
    const paginationNumber = Math.ceil(searchResultTotal / ELASTICSEARCH_PAGE_SIZE);
    const searchTextInQuery = _get(query, 'searchText');
    const jsName = getFullNameByUser(currentUser);
    const jsCountry = _get(currentUser, 'country');

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickSavedButton = useCallback(() => {
        setIsSavedView(true);
        setSortByNewest(true);
        setCurrentPageNumber(1);
        setJobList([]);
        setSearchResultTotal(0);
        setQuery(queryInitState);
    }, []);

    const handleClickAppliedButton = useCallback(() => {
        setIsSavedView(false);
        setSortByNewest(true);
        setCurrentPageNumber(1);
        setJobList([]);
        setSearchResultTotal(0);
        setQuery(queryInitState);
    }, []);

    const handleChangeSort = sortOrder => {
        setSortByNewest(sortOrder === SORT_OPTION_NEWEST_FIRST);
        if (isSavedView) {
            const newSortTag = sortOrder === SORT_OPTION_NEWEST_FIRST ? ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC : ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_ASC;
            setSortTag(newSortTag);
            setQuery(prev => ({ ...prev, sortTag: ELASTICSEARCH_SORT_OPTIONS[newSortTag] }));
        } else {
            const newSortTag = sortOrder === SORT_OPTION_NEWEST_FIRST ? ELASTICSEARCH_SORT_OPTION_APPLY_DATE_DESC : ELASTICSEARCH_SORT_OPTION_APPLY_DATE_ASC;
            setSortTag(newSortTag);
            setQuery(prev => ({ ...prev, sortTag: ELASTICSEARCH_SORT_OPTIONS[newSortTag] }));
        }
    };

    const handleClickJobTitle = useCallback(jobIdx => {
        setJobModalIdx(jobIdx);
    }, []);

    const handleClickApplyNow = useCallback(
        (jobId, employerId) => {
            applyJob({
                userId,
                jsName,
                jsCountry,
                jobId,
                employerId,
                callback: () => {
                    logEvent(ANALYTICS_EVENT_JS_APPLIED_JOB);
                },
                setSnackbarMessage,
                setSnackbarErrorMessage,
            });
        },
        [userId, jsName, jsCountry, setSnackbarMessage, setSnackbarErrorMessage],
    );

    const handleRunSearch = useCallback(
        searchText => {
            setQuery(prev => ({ ...prev, searchText, sortTag: ELASTICSEARCH_SORT_OPTIONS[sortTag] }));
            setIsSearched(true);
        },
        [sortTag],
    );

    const handleCloseBrandPageDialog = () => {
        setBrandPageDialogInfo(null);
    };

    // pagination section
    const handleChangePage = useCallback((evt, value) => {
        setCurrentPageNumber(value);
    }, []);

    const handleClearFilters = () => {
        setQuery(queryInitState);
        setSortByNewest(true);
    };

    const deleteJobFromScreen = jobId => {
        // remove the job from the screen because ElasticSearch doesn't have real-time update and will not auto refresh
        setJobList(prev => {
            const newJobList = [...prev];
            _remove(newJobList, item => item.uid === jobId);
            return newJobList;
        });

        setSearchResultTotal(prev => prev - 1);

        // remember the job Id for illusion of real-time
        setTempUnbookmarkedJobs(prev => {
            let cleanedUpList = { ...prev };
            _forEach(_keys(prev), jobId => {
                if (differenceInSeconds(new Date(), prev[jobId].deleteDt) > 30) cleanedUpList = _omit(cleanedUpList, jobId);
            });
            return { ...cleanedUpList, [jobId]: { id: jobId, deleteDt: new Date() } };
        });
    };

    const handleDeleteJob = jobId => {
        deleteJobFromScreen(jobId);
    };

    const handleSaveJobNote = (jobId, note) => {
        // update the job on the screen because ElasticSearch doesn't have real-time update and will not auto refresh
        setJobList(prev => {
            const idx = _findIndex(prev, item => item.uid === jobId);
            const foundJob = _get(prev, `[${idx}]`);
            const modifiedJob = { ...foundJob, note };
            return [..._slice(prev, 0, idx), modifiedJob, ..._slice(prev, idx + 1)];
        });

        // remember the job notes for illusion of real-time
        setTempUpdatedJobNotes(prev => {
            let cleanedUpList = { ...prev };
            _forEach(_keys(prev), jobId => {
                if (differenceInSeconds(new Date(), prev[jobId].updateDt) > 30) cleanedUpList = _omit(cleanedUpList, jobId);
            });
            return { ...cleanedUpList, [jobId]: { id: jobId, data: note, updateDt: new Date() } };
        });
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        userDateFormat,
        currentUser,
        searchResultTotal,
        myJobsData,
        jobList,
        isSavedView,
        sortByNewest,
        setSortByNewest,
        handleClickSavedButton,
        handleClickAppliedButton,
        handleChangeSort,
        handleClickJobTitle,
        jobModalIdx,
        setJobModalIdx,
        handleClickApplyNow,
        handleRunSearch,
        brandPageDialogInfo,
        setBrandPageDialogInfo,
        handleCloseBrandPageDialog,
        handleClearFilters,
        // handleDeleteJob,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <LayoutContext.Provider
            value={{ ...layoutContext, myJobsData, query, setQuery, brandPageDialogInfo, setBrandPageDialogInfo, brandPageDialogOnClose: handleCloseBrandPageDialog }}
        >
            <AfitdPageHead title={PAGE_TITLE_JS_MY_JOBS} />
            <Grid {...defns.root}>
                <Grid {...defns.header}>
                    <div {...defns.headerLeft}>
                        <div {...defns.headerTitle}>
                            <div {...defns.headerTitleText}>{DASHBOARD_MY_JOBS}</div>
                        </div>
                        <div {...defns.headerToday}>
                            <CalendarTodayIcon {...defns.todayIcon} />
                            <div {...defns.todayContainer}>
                                <AfitdTypography {...defns.todayText} />
                            </div>
                        </div>
                    </div>
                    <div {...defns.headerRight}>
                        <div {...defns.headerButtons}>
                            {/* <div>
                                <HelpOutlineIcon {...defns.helpOutlineIcon} />
                            </div> */}
                            <div>
                                <AfitdButtonGroup variant="contained" aria-label="contained button group" {...defns.savedAppliedButtonGroup}>
                                    <AfitdButton isGroup={true} {...defns.savedButton}>
                                        Saved
                                    </AfitdButton>
                                    <AfitdButton isGroup={true} {...defns.appliedButton}>
                                        Applied
                                    </AfitdButton>
                                </AfitdButtonGroup>
                            </div>
                        </div>
                    </div>
                    {/* </div>
                    <div {...defns.body}> */}
                </Grid>
                <div {...defns.myJobsSearchContainer}>
                    <SearchInput {...defns.searchInput} />
                </div>
                <Grid {...defns.content}>
                    <div {...defns.contentScrollable}>
                        <SimpleBar style={{ height: '100%' }}>
                            <div {...defns.myJobs}>
                                {/* <SearchInput {...defns.searchInput} /> */}
                                <div {...defns.searchContainer}>
                                    <AfitdTypography {...defns.jobsCountText} />
                                    <div {...defns.sortBox}>
                                        <AfitdTypography {...defns.sortText}>Sort:</AfitdTypography>
                                        <div {...defns.dropdownContainer}>
                                            <AfitdDropDown {...defns.sortDropdown} />
                                        </div>
                                    </div>
                                </div>

                                {jobList.length > 0 ? (
                                    <div>
                                        <div ref={myRef} />

                                        {jobList?.map((job, idx) => (
                                            <JobCard
                                                key={getUniqueKey()}
                                                job={job}
                                                idx={idx}
                                                onJobTitleClick={handleClickJobTitle.bind(null, idx)}
                                                onJobDelete={handleDeleteJob}
                                                onJobNoteSave={handleSaveJobNote}
                                                myJobsData={myJobsData}
                                                isSavedJob={isSavedView}
                                            />
                                        ))}

                                        <div
                                            {...defns.paginationContainer}
                                            onClick={() => {
                                                setTimeout(() => {
                                                    myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                }, 100);
                                            }}
                                        >
                                            <AfitdPagination count={paginationNumber} color="secondary" page={currentPageNumber} onChange={handleChangePage} />
                                        </div>
                                        {jobModalIdx !== null && <SingleJobDialog {...defns.jobModal} />}
                                    </div>
                                ) : (
                                    // showNoSearchIcon && (
                                    // <div {...defns.noResultContainer}>
                                    //     <SearchIcon {...defns.noResultIcon} />
                                    //     <div {...defns.noResultTextContainer}>
                                    //         <p {...defns.noResultText}>There are no employers that match the criteria</p>
                                    //         <p>Please change your filter selections and try again</p>
                                    //     </div>
                                    // </div>
                                    <div {...defns.noJobFoundContainer}>
                                        <div>
                                            <img src={noJobFound} alt="" {...defns.noJobFoundImg} />
                                        </div>
                                        {searchTextInQuery !== '' && isSearched ? (
                                            <div {...defns.noJobTextContainer}>
                                                <p {...defns.noJobListingText}>No Job listings match your search</p>
                                                <p {...defns.noJobListingPara}>Please enter more details or different search criteria</p>
                                            </div>
                                        ) : (
                                            <div {...defns.noJobTextContainer}>
                                                <p {...defns.noJobListingText}>NO JOB LISTINGS TO DISPLAY</p>
                                                <p {...defns.noJobListingPara}>Please 'save' or 'apply' to jobs on the Job Center</p>
                                            </div>
                                        )}
                                    </div>
                                    // )
                                )}
                            </div>
                        </SimpleBar>
                    </div>
                </Grid>
                <Grid {...defns.bottomFooter}>{mdMatches ? <Footer /> : null}</Grid>
            </Grid>
            {brandPageDialogOpen && <BrandPageDialog {...defns.brandPageDialog} />}
        </LayoutContext.Provider>
    );
};

export default MyJobs;
